module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DashboardLayout', [_c('template', {
    slot: "navbarFilters"
  }, [(_vm.sellerOptions.length > 1 || _vm.marketplaceOptions.length > 1) ? _c('div', {
    staticClass: "navbar-filters fee-claims-filters"
  }, [(_vm.sellerOptions.length > 1) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sellerId),
      expression: "sellerId"
    }],
    staticClass: "fee-claims-filter",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sellerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.load]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("S.Accounts: All")]), _vm._v(" "), _vm._l((_vm.sellerOptions), function(s) {
    return _c('option', {
      key: s.id,
      domProps: {
        "value": String(s.id)
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.marketplaceOptions.length > 1) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "fee-claims-filter",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.marketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.load]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Marketplaces: All")]), _vm._v(" "), _vm._l((_vm.marketplaceOptions), function(m) {
    return _c('option', {
      key: m,
      domProps: {
        "value": m
      }
    }, [_vm._v("Amazon." + _vm._s(_vm.mpSuffix(m)))])
  })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims"
  }, [_c('div', {
    staticClass: "fee-claims-content"
  }, [_c('h1', {
    staticClass: "fee-claims-title"
  }, [_vm._v("Fee Claims")]), _vm._v(" "), _c('p', {
    staticClass: "fee-claims-subtitle"
  }, [_vm._v("When Amazon re-measures a product, you may be owed money on past orders, or paying too much on new ones.")]), _vm._v(" "), (_vm.notAvailable) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v("Fee Claims isn't switched on for this account.")]) : [(_vm.showKpis) ? _c('div', {
    staticClass: "fee-claims-kpis"
  }, [_c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Ready to claim")]), _vm._v(" "), _c('div', {
    staticClass: "v green",
    class: {
      multi: _vm.kpiAmounts('readyToClaimCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('readyToClaimCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v(_vm._s(_vm.plural(_vm.kpis.readyToClaimOrders, 'order')) + " · " + _vm._s(_vm.plural(_vm.kpis.readyToClaimProducts, 'product')))])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Claim within 7 days")]), _vm._v(" "), _c('div', {
    staticClass: "v",
    class: {
      red: _vm.kpis.claimWithin7DaysCents > 0,
      multi: _vm.kpiAmounts('claimWithin7DaysCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('claimWithin7DaysCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v("oldest orders leave Amazon's 90 days")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Filed, waiting")]), _vm._v(" "), _c('div', {
    staticClass: "v",
    class: {
      multi: _vm.kpiAmounts('filedCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('filedCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v(_vm._s(_vm.plural(_vm.kpis.filedCount, 'claim')) + " open")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-kpi"
  }, [_c('div', {
    staticClass: "k"
  }, [_vm._v("Recovered")]), _vm._v(" "), _c('div', {
    staticClass: "v green",
    class: {
      multi: _vm.kpiAmounts('recoveredCents').length > 1
    }
  }, _vm._l((_vm.kpiAmounts('recoveredCents')), function(a, i) {
    return _c('span', {
      key: i
    }, [_vm._v(_vm._s(a))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "s"
  }, [_vm._v("since you started")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-sumbar"
  }, [_c('button', {
    staticClass: "fee-claims-btn green",
    attrs: {
      "type": "button",
      "disabled": !_vm.counts.to_claim || _vm.downloadingAll
    },
    on: {
      "click": _vm.downloadAll
    }
  }, [_c('i', {
    class: _vm.downloadingAll ? 'notched circle loading icon' : 'download icon'
  }), _vm._v("\n            Download all claimable orders (XLSX)\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "fee-claims-muted"
  }, [_vm._v("Every product in one file: Summary, Orders to claim, How to file.")]), _vm._v(" "), _c('button', {
    staticClass: "fee-claims-howlink",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.howOpen = !_vm.howOpen
      }
    }
  }, [_vm._v("How to claim")])]), _vm._v(" "), (_vm.downloadError) ? _c('div', {
    staticClass: "fee-claims-error"
  }, [_vm._v(_vm._s(_vm.downloadError))]) : _vm._e(), _vm._v(" "), (_vm.howOpen) ? _c('div', {
    staticClass: "fee-claims-how"
  }, [_c('ol', [_c('li', [_vm._v("Download the order list for the product.")]), _vm._v(" "), _c('li', [_vm._v("In Seller Central, open a Seller Support case for FBA fees and attach the file.")]), _vm._v(" "), _c('li', [_vm._v("When Amazon refunds it, mark it here as Refunded.")])]), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-muted"
  }, [_vm._v("Amazon only looks at orders from the last 90 days, so claim the oldest first.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-seg"
  }, _vm._l((_vm.tabs), function(t) {
    return _c('button', {
      key: t.key,
      class: {
        on: _vm.filter === t.key
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.setFilter(t.key)
        }
      }
    }, [_vm._v(_vm._s(t.label) + " (" + _vm._s(_vm.counts[t.key] || 0) + ")")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "fee-claims-table"
  }, [_c('div', {
    staticClass: "fee-claims-head"
  }, [_c('div', [_vm._v("Product")]), _vm._v(" "), _c('div', [_vm._v("What Amazon changed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.isFeeUp ? 'New fee' : 'Orders'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.isFeeUp ? 'Extra / unit' : 'Amount'))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.filter === 'to_claim' ? 'Claim by' : ''))]), _vm._v(" "), _c('div', [_vm._v("Status")])]), _vm._v(" "), (_vm.loading && !_vm.claims.length) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" Loading…")]) : (_vm.loadError) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v(_vm._s(_vm.loadError))]) : (!_vm.claims.length) ? _c('div', {
    staticClass: "fee-claims-empty"
  }, [_vm._v("Nothing here.")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.claims), function(c) {
    return _c('div', {
      key: c.id,
      staticClass: "fee-claims-row"
    }, [_c('div', {
      staticClass: "prod"
    }, [(c.imageUrl) ? _c('img', {
      staticClass: "img",
      attrs: {
        "src": c.imageUrl,
        "alt": "",
        "loading": "lazy"
      }
    }) : _c('div', {
      staticClass: "img placeholder"
    }, [_c('i', {
      staticClass: "image icon"
    })]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "t"
    }, [_vm._v(_vm._s(c.title))]), _vm._v(" "), _c('div', {
      staticClass: "mono"
    }, [_vm._v(_vm._s(c.sellerSku) + " · " + _vm._s(c.asin) + " · " + _vm._s(c.marketplace))])])]), _vm._v(" "), _c('div', {
      staticClass: "what"
    }, [_vm._l((c.evidence), function(e, i) {
      return _c('div', {
        key: i
      }, [_vm._v(_vm._s(_vm.measureLabel(e.measure)) + ": " + _vm._s(e.text))])
    }), _vm._v(" "), (!c.evidence || !c.evidence.length) ? _c('div', [_vm._v("Re-measured by Amazon")]) : _vm._e(), _vm._v(" "), (c.matchesListing) ? _c('div', {
      staticClass: "good"
    }, [_vm._v("Now matches your listing")]) : _vm._e(), _vm._v(" "), (c.reversesChangeOn) ? _c('div', {
      staticClass: "small"
    }, [_vm._v("Reverses the increase on " + _vm._s(_vm.shortDate(c.reversesChangeOn)))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.shortDate(c.feeChangedOn)) + " · " + _vm._s(_vm.money(c.previousFeeCents, c.currency)) + " → " + _vm._s(_vm.money(c.currentFeeCents, c.currency)))])], 2), _vm._v(" "), _c('div', {
      staticClass: "num"
    }, [(_vm.isUp(c)) ? [_vm._v(_vm._s(_vm.money(c.currentFeeCents, c.currency)))] : (c.orderListStatus === 'pending') ? [_c('span', {
      staticClass: "fee-claims-muted"
    }, [_vm._v("Checking…")])] : [_vm._v(_vm._s(c.orders != null ? c.orders : '—'))]], 2), _vm._v(" "), _c('div', {
      staticClass: "amt",
      class: _vm.isUp(c) ? 'amber' : 'green'
    }, [(_vm.isUp(c)) ? [_vm._v("+" + _vm._s(_vm.money(c.currentFeeCents - c.previousFeeCents, c.currency)))] : (c.claimCents != null) ? [_vm._v(_vm._s(_vm.money(c.claimCents, c.currency)))] : [_vm._v("—")]], 2), _vm._v(" "), _c('div', {
      staticClass: "when"
    }, [(_vm.filter === 'to_claim' && c.claimBy) ? _c('div', {
      class: {
        soon: c.claimByDueSoon
      }
    }, [_vm._v(_vm._s(_vm.shortDate(c.claimBy)))]) : _vm._e(), _vm._v(" "), (c.downloadUrl && !_vm.isUp(c) && _vm.filter !== 'done') ? _c('a', {
      staticClass: "fee-claims-btn green small",
      attrs: {
        "href": c.downloadUrl,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("Download orders")]) : _vm._e(), _vm._v(" "), (_vm.isUp(c) && c.productId) ? _c('button', {
      staticClass: "fee-claims-btn small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.viewProduct(c)
        }
      }
    }, [_vm._v("View product")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('select', {
      staticClass: "fee-claims-status",
      attrs: {
        "disabled": _vm.savingId === c.id
      },
      domProps: {
        "value": c.status
      },
      on: {
        "change": function($event) {
          return _vm.setStatus(c, $event.target.value)
        }
      }
    }, _vm._l((c.statuses), function(s) {
      return _c('option', {
        key: s,
        domProps: {
          "value": s
        }
      }, [_vm._v(_vm._s(_vm.statusLabel(s)))])
    }), 0)])])
  })], 2)]], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de9b34fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/FeeClaimsPage.vue
// module id = 817
// module chunks = 2